import { routerReducer as ngrxRouterReducer } from '@ngrx/router-store';

export const routerFeatureKey = 'router';

export const routerReducer = ngrxRouterReducer;
